import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import './App.css';
import CustomCursor from './components/common/CustomCursor';
import Preloader from './components/common/Preloader';
import PremiumNavbar from './components/common/PremiumNavbar';
import HeroSection from './components/sections/HeroSection';
import StatsSection from './components/sections/StatsSection';
import PremiumAbout from './components/sections/PremiumAbout';
import PremiumSkills from './components/sections/PremiumSkills';
import ExperienceTimeline from './components/sections/ExperienceTimeline';
import PremiumServices from './components/sections/PremiumServices';
import PremiumProjects from './components/sections/PremiumProjects';
import Footer from './components/Footer';
import ContactSection from './components/sections/ContactSection';
import ScrollToTop from './components/ScrollToTop';

function App() {
  useEffect(() => {
    const isFinePointer = window.matchMedia('(pointer: fine)').matches;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isFinePointer && !reducedMotion) {
      document.documentElement.classList.add('has-custom-cursor');
    }
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="App bg-dark-900">
        <Preloader />
        <CustomCursor />
        <PremiumNavbar />
        <HeroSection />
        <StatsSection />
        <PremiumAbout />
        <PremiumSkills />
        <ExperienceTimeline />
        <PremiumServices />
        <PremiumProjects />
        <ContactSection />
        <Footer />
        <ScrollToTop />
      </div>
    </MotionConfig>
  );
}

export default App;
